// Nurses Week seasonal banner palette: cream → warm gold gradient with a gold
// pill accent, mirroring the Figma design. Scoped to this limited-time campaign
// and intentionally kept out of the core palette.

/* eslint-disable no-restricted-syntax -- seasonal one-off palette, not worth adding to core theme */
// eslint-disable-next-line cbh-rules/no-inline-gradient -- TODO: migrate to theme palette gradient
export const NURSES_WEEK_BANNER_GRADIENT = "linear-gradient(140.89deg, #FFFAF0 1%, #FAE7A4 99%)";
export const NURSES_WEEK_PILL_BACKGROUND = "#FFE599";
export const NURSES_WEEK_PILL_TEXT = "#6C4A00";
export const NURSES_WEEK_TEXT_COLOR = "#0C1C43";
/* eslint-enable no-restricted-syntax */
